import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FilterProductPreview} from "../interface/filter-product-preview";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {JWTService} from "../../authentication/jwt.service";
import {WishlistService} from "../../wishlist/wishlist.service";
import {FabricFilterProductRelatedPreview} from "../interface/fabric-filter-product-related-preview";

@Component({
	selector: 'fb-filter-product-grid',
	templateUrl: './filter-product-grid.component.html',
	styleUrls: ['./filter-product-grid.component.scss']
})
export class FilterProductGridComponent implements OnInit, OnChanges {

	@Input()
	public products: FabricFilterProductRelatedPreview[] = [];
	@Input()
	public productGroup: string = '';
	public selectedCurrency: ApCurrency = ApCurrency.UNKNOWN;
	public isLoggedIn: boolean = false;

	constructor(
		private _currencyResolver: CurrencyResolverService,
		private _jwt: JWTService,
		private _wishlist: WishlistService
	) {
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.checkInWishlist();

		this._wishlist.wishlistItems.subscribe(() => {
			this.checkInWishlist();
		})
    }
	ngOnInit(): void {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(() => {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		this.isLoggedIn = this._jwt.hasValidJWT();
	}


	private checkInWishlist(): void {
		this.products.forEach((product) => {
			product.product.inWishlist = this._wishlist.isInWishlist(product.product.sku);
		});
	}
}
